import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { GuidedHouseholdReviewGoalPriorityLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

const layout = withGuidedHouseholdReviewLayout(GuidedHouseholdReviewGoalPriorityLayout);

export const GuidedHouseholdReviewGoalPriorityPageTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={layout}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink }}
      resource={resource}
    />
  );
};

GuidedHouseholdReviewGoalPriorityPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
